import React from "react";

function Section({ title, children }) {
  return (
    <section className="mt-8">
      <h2 className="text-lg font-bold">{title}</h2>
      <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-600">
        {children}
      </div>
    </section>
  );
}

export default function Privacy() {
  return (
    <div className="section-container max-w-3xl py-16">
      <h1 className="text-3xl font-bold sm:text-4xl">Privacy Policy</h1>
      <p className="mt-2 text-sm text-slate-500">Last updated: May 20, 2026</p>

      <p className="mt-6 text-sm leading-relaxed text-slate-600">
        At Money Flow Accounting, we take your privacy seriously. This Privacy Policy
        explains how we collect, use, disclose, and protect your information
        when you use our accounting software and services.
      </p>

      <Section title="1. Information We Collect">
        <ul className="list-disc space-y-2 pl-5">
          <li>
            <strong className="text-navy">Personal Information:</strong> Name,
            email address, phone number, company name, and billing
            information.
          </li>
          <li>
            <strong className="text-navy">Business Information:</strong>{" "}
            Financial data, transaction records, and other business
            information you upload or enter.
          </li>
          <li>
            <strong className="text-navy">Usage Information:</strong> How you
            use our services, features, and interactions with our platform.
          </li>
        </ul>
      </Section>

      <Section title="2. How We Use Your Information">
        <ul className="list-disc space-y-2 pl-5">
          <li>Provide and maintain our accounting software and services</li>
          <li>Process transactions and send important notifications</li>
          <li>Improve our products and user experience</li>
          <li>Provide customer support and respond to inquiries</li>
          <li>Comply with legal obligations and prevent fraud</li>
        </ul>
      </Section>

      <Section title="3. Information Sharing">
        <p>
          We do not sell, trade, or rent your personal information. We may
          share your information only in the following circumstances:
        </p>
        <ul className="list-disc space-y-2 pl-5">
          <li>With service providers who help us operate our platform</li>
          <li>When required by law or to protect our rights</li>
          <li>With your consent</li>
        </ul>
      </Section>

      <Section title="4. Data Security">
        <p>
          We implement industry-standard security measures to protect your
          information, including encryption, secure servers, and regular
          security audits.
        </p>
      </Section>

      <Section title="5. Your Rights">
        <p>
          You have the right to access, update, or delete your personal
          information. You can also export your data at any time. To exercise
          any of these rights, contact us at{" "}
          <a
            href="mailto:privacy@accountrix.com"
            className="font-medium text-primary hover:underline"
          >
            privacy@accountrix.com
          </a>
          .
        </p>
      </Section>
    </div>
  );
}
